import { FC } from 'react';
import { Helmet } from 'react-helmet-async';

import {
  Calculation,
  calculationMode,
} from '@/components/Calculation/Calculation';

export const Addition: FC = () => {
  return (
    <>
      <Helmet>
        <title>Jula - Addition</title>
      </Helmet>
      <Calculation mode={calculationMode.addition} />
    </>
  );
};
